import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70" role="contentinfo">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <span className="font-heading text-xl font-bold text-foreground-950 tracking-wide block mb-4">
              第一次指南
            </span>
            <p className="text-sm text-foreground-600 leading-relaxed">
              帮助每一个面对「第一次」的你，从紧张到自信，让每一次全新体验都成为人生高光时刻。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4">
              <a href="#footer-categories" className="cursor-pointer">内容分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/career" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  职场生涯
                </Link>
              </li>
              <li>
                <Link to="/category/relationship" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  人际情感
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-950 mb-4">
              关注我们
            </h4>
            <p className="text-sm text-foreground-600 mb-4 leading-relaxed">
              持续更新「第一次」经验分享，陪伴你的每一次成长。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 hover:bg-primary-100 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 hover:bg-primary-100 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 hover:bg-primary-100 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer" aria-label="小红书" rel="nofollow">
                <i className="ri-chat-smile-2-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 第一次指南. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}